import { ValidationArguments, ValidatorConstraint, ValidatorConstraintInterface } from 'class-validator';
import { CustomCommonValidator } from './customCommonValidator';

@ValidatorConstraint()
export class TourItineraryProductValidator extends CustomCommonValidator implements ValidatorConstraintInterface {
	validate(items: TourItineraryProductItem[], validationArguments: ValidationArguments): boolean {
		//const displayNames: { [language: string]: string[] } = {};
		//for (let item of items) {
		//	const names = { ...item.dynamicProperties['displayName'] };
		//	delete names['__isProxy']; // just in case the object is a proxy
		//	delete names['@odata.type']; // when the object come from the server
		//	for (let language of Object.getOwnPropertyNames(names)) {
		//		if (!(language in displayNames)) {
		//			displayNames[language] = [];
		//		}

		//		if (displayNames[language].some((m) => m === names[language])) {
		//			this.message = `There are two children with the same name [${names[language]}]`
		//			return false;
		//		}

		//		displayNames[language].push(names[language]);
		//	}
		//}

		return true;
	}
}



// WEBPACK FOOTER //
// ./src/core/customValidator/tour-itinerary-product-validator.ts